import { money } from "../utils";

const RecoverableRevenueCard = ({ value }) => {
  return (
    <div className="card">
      <div className="opacity-70">Recoverable Revenue</div>
      <div className="text-xs opacity-60 mt-1">
        Revenue that can be recovered with focused follow-up actions.
      </div>
      <div className="text-xl font-bold mt-1">{money(value)}</div>
    </div>
  );
};

export default RecoverableRevenueCard;
